import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusNgOffice.tsx
const IconApplicationStatusNgOffice = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M17.5 15.833h1.667V17.5H.834v-1.667h1.667v-12.5a.833.833 0 0 1 .833-.833h8.333a.833.833 0 0 1 .834.833v12.5h1.666V7.5h2.5a.833.833 0 0 1 .834.833zM5.835 9.167v1.666h3.333V9.167zm0-3.334V7.5h3.333V5.833z"
	})]
});
var IconApplicationStatusNgOffice_default = forwardRef(IconApplicationStatusNgOffice);
//#endregion
export { IconApplicationStatusNgOffice_default as default };
